import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="bg-ink-900 px-5 py-14 sm:px-8 sm:py-20" data-id="element-103" data-mp="1clz9obpw4bzq">
      <div className="mx-auto max-w-5xl" data-id="element-104" data-mp="18k4bvh764gqp">
        <p className="text-center font-display text-sm font-bold uppercase tracking-[0.24em] text-teal-300" data-id="element-105" data-mp="18l5m5jgd0z7d">
          But there’s more…
        </p>
        <div className="mt-4" data-id="element-106" data-mp="20b0gjuj2rf2w">
          <SectionHeading title="Your Master System of TRT™ Comes With 5 Practical Clinical Bonuses" subtitle="Because having the knowledge is only part of the equation. The real advantage comes from being able to apply it quickly when you’re facing a real patient." data-id="element-107" data-mp="20c22wv5jjnzx" />
        </div>

        <p className="mx-auto mt-5 max-w-2xl text-center text-[15px] leading-relaxed text-white/70 sm:text-base" data-id="element-108" data-mp="kvbd7cz5vuse">
          That’s why we’ve added 5 practical resources designed to help you move from learning →
          applying → reviewing.
        </p>

        <div className="mt-9 space-y-4 sm:space-y-5" data-id="element-109" data-mp="1jt9o2ghrwpv2">
          {bonuses.map(bonus => <article key={bonus.tag} className="rounded-2xl border border-teal-400/25 bg-ink-800/70 p-5 sm:p-7" data-id="element-110" data-mp="15ti47z4ksf95">
              <div className="flex flex-wrap items-center gap-3" data-id="element-111" data-mp="1aq8lgps49gw5">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-teal-400 px-3 py-1 font-display text-xs font-bold uppercase tracking-[0.14em] text-ink-900" data-id="element-112" data-mp="w24903jnq1lt">
                  <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-113" data-mp="n30piygkvk6s" />
                  {bonus.tag}
                </span>
                <span className="text-[11px] font-bold uppercase tracking-[0.12em] text-white/50" data-id="element-114" data-mp="r540llzc4mrj">
                  Value: <span className="line-through" data-id="element-115" data-mp="d5m92yunmveh">{bonus.value}</span>
                  <span className="ml-2 text-teal-300" data-id="element-116" data-mp="i3xix9ky95wp">Included today: Free</span>
                </span>
              </div>

              <div className="mt-5 overflow-hidden rounded-xl bg-white p-2 sm:p-3" data-id="element-117" data-mp="2jtd77wjpwv6v">
                <img src={bonus.image} alt={`${bonus.title} — ${bonus.subtitle}`} className="mx-auto w-full max-w-lg" width={1254} height={1254} loading="lazy" data-id="element-118" data-mp="2f1lb76hslx9c" />
              </div>

              <h3 className="mt-5 font-display text-xl font-bold uppercase leading-tight text-white sm:text-2xl" data-id="element-119" data-mp="32qefbq8kjbf1">
                {bonus.title}
              </h3>
              <p className="mt-1 text-sm font-semibold text-teal-200 sm:text-base" data-id="element-120" data-mp="2tqrdx4fua5lz">
                {bonus.subtitle}
              </p>
              <p className="mt-3 text-sm leading-relaxed text-white/70 sm:text-[15px]" data-id="element-121" data-mp="2oqlg16iz7mvg">
                {bonus.intro}
              </p>
              {bonus.lead ? <p className="mt-4 text-[11px] font-bold uppercase tracking-[0.14em] text-white/45" data-id="element-122" data-mp="1dcrdztgzufyq">
                  {bonus.lead}
                </p> : null}
              <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-123" data-mp="136gfjsfptiu0">
                {bonus.items.map(item => <li key={item} className="flex items-start gap-2" data-id="element-124" data-mp="185b8vobb6psd">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal-400" aria-hidden="true" data-id="element-125" data-mp="1d5fnt9wkjcgh" />
                    <span className="text-[13px] leading-snug text-white/85 sm:text-sm" data-id="element-126" data-mp="1lztzl2hw44uu">
                      {item}
                    </span>
                  </li>)}
              </ul>
              {'footer' in bonus && bonus.footer ? <p className="mt-4 text-[13px] leading-relaxed text-white/60 sm:text-sm" data-id="element-127" data-mp="1vvdx1tc3rblp">
                  {bonus.footer}
                </p> : null}
            </article>)}
        </div>

        <div className="mx-auto mt-10 max-w-md" data-id="element-128" data-mp="6iaa53ayymeo">
          <CtaButton label="Get All 5 Bonuses Free" subLabel="Included today with your USD 27 access" data-id="element-129" data-mp="6itwqxbkdyz1" />
        </div>
      </div>
    </section>;
}